module.exports = __webpack_public_path__ + "static/media/item3.15c6626c.jpg";